import React, { FC } from "react";
import { IconProps } from "@shared/ui/Icon/ui/types";

export const GeoIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="13"
        fill="none"
    >
        <path
            fill="#3B85F7"
            fillRule="evenodd"
            d="M7.237 4.7c-1.07 0-1.936.875-1.936 1.953 0 1.077.866 1.952 1.936 1.952 1.07 0 1.936-.875 1.936-1.952A1.944 1.944 0 0 0 7.237 4.7Zm-.865 1.953c0-.483.388-.873.865-.873s.865.39.865.873a.869.869 0 0 1-.865.872.869.869 0 0 1-.865-.872Z"
            clipRule="evenodd"
        />
        <path
            fill="#3B85F7"
            fillRule="evenodd"
            d="M7.237 1.875c-2.622 0-4.737 2.16-4.737 4.813 0 1.705.986 3.304 1.984 4.437a10.12 10.12 0 0 0 1.494 1.396c.228.17.445.311.637.413.167.088.397.191.622.191.225 0 .454-.103.621-.191.192-.102.41-.243.637-.412.456-.34.988-.821 1.495-1.397.998-1.133 1.984-2.732 1.984-4.437 0-2.653-2.116-4.813-4.737-4.813Zm.62 9.779a3.95 3.95 0 0 1-.495.323 1.24 1.24 0 0 1-.125.059 1.24 1.24 0 0 1-.125-.059 3.95 3.95 0 0 1-.496-.323 9.053 9.053 0 0 1-1.331-1.245c-.935-1.062-1.714-2.41-1.714-3.72 0-2.067 1.646-3.735 3.666-3.735s3.665 1.668 3.665 3.734c0 1.31-.779 2.66-1.714 3.72a9.06 9.06 0 0 1-1.33 1.246Z"
            clipRule="evenodd"
        />
    </svg>
);